import React from 'react'

/** Component shares layout structure between pages. Pass common sections like header, footer and content container here and wrap page components with it */
const CookieContainer = ({ children }: any) => {
  return <div>{children}</div>
}

export default CookieContainer
